import { createStore } from 'vuex'
import RegionApi from "../api/RegionApi";
import UserApi from "../api/UserApi";
import {setCookie} from "tiny-cookie";
import {Listeners} from "../constants/listeners";
import {emitter} from "../plugins/emitter";

export const store = createStore({
    state: {
        database: {
            sename: null,
            dbname: null
        },
        user: {
            apiToken: null,
            authState: null,
            canGenerateApiToken: null,
            currentTariff: {
                number: null,
                label: null,
            },
            realTariff: {
                number: null,
                label: null,
            },
            email: null,
            events: [],
            id: null,
            isCurrentTariffPayed: null,
            lastPaySumm: null,
            limitNumber: null,
            parent: null,
            parentEmail: null,
            partnerBalance: null,
            payedDate: null,
            phone: null,
            subscriptionId: null,
            usedLimit: null,
            isTelegramConnected: null,
            deleteAt: null,
        },
        isCurrentTariffPayed: Boolean,
        isUserLoaded: false,
    },
    getters: {
        DATABASE: state => {
            return state.database;
        },
        USER: state => {
            return state.user;
        },
        IS_USER_AUTHENTICATED: state => {
            return state.user && state.user.authState > 0;
        },
        IS_USER_LOADED: state => {
            return state.isUserLoaded;
        },
        IS_LOADED_DATABASE: state => {
            return state.database.dbname !== null;
        },
        IS_CURRENT_TARIFF_PAYED: state => {
            return state.user && state.user.isCurrentTariffPayed;
        },
        IS_ENABLE_ONLINE_WS: state => {
            return state.user && state.user.isCurrentTariffPayed && [4, 5].includes(state.user.currentTariff.number);
        }
    },
    mutations: {
        SET_DATABASE: (state, payload) => {
            if (payload.dbname) {
                setCookie('dbname', payload.dbname);
            }

            if (payload.sename) {
                setCookie('engine', payload.sename);
            }

            state.database = payload;
        },
        SET_USER: (state, payload) => {
            state.user = payload;
            state.isUserLoaded = true;
        }
    },
    actions: {
        async GET_DATABASE(context) {
            let response = await RegionApi.getCurrentDB();
            context.commit('SET_DATABASE', response);
            emitter.emit(Listeners.GLOBAL_STORE_GET_DATABASE, response);
        },
        async GET_USER(context) {
            let response = await UserApi.getCurrent();
            context.commit('SET_USER', response);
            emitter.emit(Listeners.GLOBAL_STORE_GET_USER, response);
        }
    },
});
